import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import {
  applyRideMlPathIgnoredByWaypoints,
  ConfirmResult,
  IRideDto,
  IRideMetadata,
  rideHasActiveSavedMlPath,
} from "@ryde/shared";

import { useModalConfirm } from "../../hooks-singletons";

export interface IRideMlPathWaypointConfirmResult {
  confirmed: boolean;
  nextMetadata?: IRideMetadata;
}

export const useRideMlPathWaypointConfirm = () => {
  const { t } = useTranslation();
  const { confirmDialogResult } = useModalConfirm();

  const confirmWaypointChangeWithSavedMlPath = useEvent(
    async (
      rideDto: Partial<IRideDto>,
    ): Promise<IRideMlPathWaypointConfirmResult> => {
      if (!rideHasActiveSavedMlPath(rideDto.metadata)) {
        return { confirmed: true };
      }

      const confirmationResult = await confirmDialogResult({
        title: t("ride.SAVE_ROUTE.WAYPOINTS_ML_PATH_CONFIRM_TITLE"),
        message: t("ride.SAVE_ROUTE.WAYPOINTS_ML_PATH_CONFIRM_TEXT"),
      });

      if (confirmationResult !== ConfirmResult.OK) {
        return { confirmed: false };
      }

      return {
        confirmed: true,
        nextMetadata: applyRideMlPathIgnoredByWaypoints(rideDto.metadata ?? {}),
      };
    },
  );

  return { confirmWaypointChangeWithSavedMlPath };
};
